// Ranking global (servidor). El puntaje se registra con la sesión del
// jugador; el backend deriva el player del Bearer y valida todo en servidor.
export async function fetchRanking(limit = 100) {
  const safeLimit = Math.min(Math.max(Number.parseInt(limit, 10) || 100, 1), 100);
  const response = await fetch(`/api/ranking?limit=${encodeURIComponent(safeLimit)}`, {
    headers: { Accept: 'application/json' },
  });
  const data = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(data.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    throw error;
  }
  return data;
}

async function authenticatedPost(url, payload, token) {
  const sessionToken = token ?? localStorage.getItem('nacanaca-session') ?? '';
  if (!sessionToken) throw new Error('Inicia sesión para registrar la partida.');
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 6000);
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(payload),
      signal: controller.signal,
      keepalive: true,
    });
    const data = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
    if (!response.ok) {
      const error = new Error(data.error || `El servidor respondió ${response.status}.`);
      error.status = response.status;
      throw error;
    }
    return data;
  } finally { clearTimeout(timeout); }
}

export const sanitizeAttemptLocation = (location) => {
  if (!location || typeof location !== 'object' || Array.isArray(location)) return undefined;
  const rawLat = location.lat ?? location.latitude;
  const rawLon = location.lon ?? location.longitude;
  if (rawLat == null || rawLat === '' || rawLon == null || rawLon === '') return undefined;
  const lat = Number(rawLat);
  const lon = Number(rawLon);
  if (!Number.isFinite(lat) || lat < -90 || lat > 90 || !Number.isFinite(lon) || lon < -180 || lon > 180) return undefined;

  const normalized = { lat, lon };
  const accuracy = Number(location.accuracy);
  if (location.accuracy != null && Number.isFinite(accuracy) && accuracy >= 0 && accuracy <= 10000) {
    normalized.accuracy = accuracy;
  }
  return normalized;
};

export const startPlayAttempt = ({
  mode, zone, speedMultiplier, toleranceLevel, challengeToken, challengeId,
  tournamentToken, tournamentId, location,
}) => (
  authenticatedPost('/api/plays/start', {
    mode,
    zone,
    speedMultiplier,
    toleranceLevel,
    challengeToken,
    challengeId,
    tournamentToken,
    tournamentId,
    location: sanitizeAttemptLocation(location),
  })
);

export const sendPlayEvidence = (batch, token) => authenticatedPost(
  batch.kind === 'finish' ? '/api/plays/finish' : '/api/plays/events', batch, token,
);

// Salón de medallas propio calculado en servidor desde las partidas guardadas.
export async function fetchMyAchievements() {
  const sessionToken = localStorage.getItem('nacanaca-session') || '';
  if (!sessionToken) {
    const error = new Error('Sin sesión de jugador.');
    error.status = 401;
    throw error;
  }
  const response = await fetch('/api/achievements', {
    headers: { Accept: 'application/json', Authorization: `Bearer ${sessionToken}` },
  });
  const data = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(data.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    throw error;
  }
  return data;
}
